import type { Language } from '../types';
import { isSupportedAppLanguage } from '../i18n-locale';

const STORAGE_KEY = 'clubhouse_ui_language';

export function loadGuestLanguagePreference(): Language | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value && isSupportedAppLanguage(value) ? value : null;
  } catch {
    return null;
  }
}

export function saveGuestLanguagePreference(language: Language) {
  if (typeof localStorage === 'undefined') {
    return;
  }

  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // ignore storage failures
  }
}

export function clearGuestLanguagePreference() {
  if (typeof localStorage === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore storage failures
  }
}
